import React, { useRef } from "react";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import { handleRadioKeyDown } from "@/utils/common/radio-accessibility";

const DeviceOrder = ({ sortingKeys, orderSelected, handleOnChangeOrder }) => {
  const radioRefs = useRef([]);

  return (
    <div className="devicesOrder" role="radiogroup" aria-label="Ordenar resultados">
      <TextInfo
        text="Ordenar:"
        size={TEXT_SIZE.SUBTITLE2}
        color={TEXT_COLOR.MOVISTAR_BLACK}
        fontType={TEXT_FONT_WEIGHT.REGULAR}
      />
      {sortingKeys?.map((sortingKey, index) => (
        <React.Fragment key={sortingKey.id}>
          <span
            className="deviceOrderOption"
            data-cy={`deviceOrderOption ${sortingKey.name}`}
            role="radio"
            tabIndex={orderSelected === sortingKey.id ? 0 : -1}
            aria-checked={orderSelected === sortingKey.id}
            ref={(el) => (radioRefs.current[index] = el)}
            onClick={() => handleOnChangeOrder(sortingKey.id)}
            onKeyDown={(e) =>
              handleRadioKeyDown(e,
                radioRefs,
                index, 
                (selectedIndex) => handleOnChangeOrder(sortingKeys[selectedIndex].id)
              )
            }
          >
            <TextInfo
              text={sortingKey.name}
              size={TEXT_SIZE.SUBTITLE2}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={
                orderSelected === sortingKey.id
                  ? TEXT_FONT_WEIGHT.BOLD
                  : TEXT_FONT_WEIGHT.REGULAR
              }
            />
          </span>
          {index !== sortingKeys.length - 1 && " | "}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DeviceOrder;
